



















































































































import { Component, Vue } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, CreateTransporterDriverProfile } from '@/types/request';
import { MedTransGoConstants } from '@/util/constants';
import { TransporterLoc } from '@/types/entity';
import { CommonUtils } from '@/util/commonUtils';
import { ModelSelect } from 'vue-search-select';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { DateUtils } from '@/util/dateUtils';
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');
const mmddyyyyRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(19|20)\d\d$/;
const mmddyyyyFormat = (value: string) => {
  return mmddyyyyRegex.test(value);
};
const parseMMDDYYYY = (value: string): Date | null => {
  if (!value || value.length !== 10) {
    return null;
  }
  const [month, day, year] = value.split('/');
  const mm = parseInt(month, 10);
  const dd = parseInt(day, 10);
  const yyyy = parseInt(year, 10);
  if (isNaN(mm) || isNaN(dd) || isNaN(yyyy)) {
    return null;
  }
  const date = new Date(yyyy, mm - 1, dd);
  if (
    date.getFullYear() !== yyyy ||
    date.getMonth() !== mm - 1 ||
    date.getDate() !== dd
  ) {
    return null;
  }
  return date;
};

const validBirthDate = (value: string): boolean => {
  const parsed = parseMMDDYYYY(value);
  if (!parsed) {
    return false;
  }
  const ageLimit = new Date();
  ageLimit.setFullYear(ageLimit.getFullYear() - 23);
  return parsed <= ageLimit;
};

const validExpireDate = (value: string): boolean => {
  const parsed = parseMMDDYYYY(value);
  if (!parsed) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return parsed >= today;
};



@Component({
    mixins: [validationMixin],
    components: {
            ModelSelect,
    },
    data() {
        return {
            licenceNumber: '',
            licenceState: '',
            birthDate: '',
            locationId: '',
            expireDate: '',
            options: [],
            locationOptions: [],
            licenceStates: ProfileFormData.licenceStates,
            birthDateFormatted: '',
            expireDateFormatted: '',

        };
    },
    directives: {
        dateFormat: {
            bind(el) {
                el.addEventListener('input', (e: any) => {
                    if (e && e.target && e.target) {
                        const input = e.target;
                        const selectionStart = input.selectionStart;
                        let value = input.value.replace(/\D/g, '');
                        if (value.length > 2) {
                        value = value.substring(0, 2) + '/' + value.substring(2);
                        }
                        if (value.length > 5) {
                        value = value.substring(0, 5) + '/' + value.substring(5, 9);
                        }
                        input.value = value;
                        let newPosition = selectionStart;
                        if (selectionStart === 3 || selectionStart === 6) {
                        newPosition += 1;
                        }
                        input.setSelectionRange(newPosition, newPosition);
                    }
                });
            },
        },
    },
    validations: {
        licenceNumber: {
            required,
        },
        licenceState: {
            required,
        },
        birthDate: {
            required,
        },
        expireDate: {
            required,
        },
        birthDateFormatted: {
            required,
            mmddyyyyFormat,
            validBirthDate,
        },
        expireDateFormatted: {
            required,
            mmddyyyyFormat,
            validExpireDate,
        },
    },
})

export default class AddTransporterDriverDetailsModal extends Vue {
    private show = true;
    private maxDate = new Date();
    private locations: TransporterLoc[] | undefined = [];
    private birthDateFormatted: string = '';
    private expireDateFormatted: string = '';
    private expireDate: string = '';
    private birthDate: string = '';



    public mounted() {
        this.$data.options = [];
        this.getLocation();

        this.maxDate.setFullYear(this.maxDate.getFullYear() - 23);
        this.$data.licenceStates.forEach((licenceState: any) => {
                const option = {
                    value: licenceState.name,
                    text: licenceState.name,
                };
                this.$data.options.push(option);
            });

    }

     private async getLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/list`,
                loaderEvent: {
                    show: true,
                },
            };
        const response = await iHttpService.get<TransporterLoc[]>(apiRequest);
        if (response.success && response.data) {
                this.$data.locationOptions = [];
                this.locations = response.data as any;
                response.data.forEach((location) => {
                const option = {
                    value: location.id,
                    text: location.branchName,
                };
                this.$data.locationOptions.push(option);
                });
            } else {
                CommonUtils.showError(response);
            }
    }

    private async addTransporterAsDriver() {
        const iHttpService = ObjectFactory.getHttpService();
        const addTransporterAsDriver: CreateTransporterDriverProfile = {
            birthDate: this.$data.birthDate,
            expireYear: this.$data.expireDate,
            licenceNo: this.$data.licenceNumber,
            licenceState: this.$data.licenceState,
            locationId: this.$data.locationId,
        };
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/TransporterAsdriver/add`,
                data: addTransporterAsDriver,
                loaderEvent: {
                    show: true,
                },
            };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success && response.data) {
            const toastEvent: ToastEvent = {
                    message: 'Driver Added Successfully',
                    title: 'Success',
                    timeout: 5000,
                    varient: 'success',
                };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            } else {
                CommonUtils.showError(response);
                this.close();
            }
    }

    private close() {
        this.$emit('close');
    }
    private onBirthDateSelect(ctx: any) {
        if (ctx.selectedDate) {
            const date = new Date(ctx.selectedDate);
            this.birthDateFormatted = this.formatToMMDDYYYY(date);
        }
    }

    private onExpireDateSelect(ctx: any) {
        if (ctx.selectedDate) {
            const date = new Date(ctx.selectedDate);
            this.expireDateFormatted = this.formatToMMDDYYYY(date);
        }
    }

    private onBirthInput() {
        this.$v.birthDateFormatted.$touch();
        const parsed = this.parseMMDDYYYY(this.birthDateFormatted);
        if (parsed) {
            const ageLimitDate = new Date();
            ageLimitDate.setFullYear(ageLimitDate.getFullYear() - 23);
            ageLimitDate.setHours(0, 0, 0, 0);
            if (parsed <= ageLimitDate) {
                this.birthDate = `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}-${String(parsed.getDate()).padStart(2, '0')}`;
            } else {
                this.birthDate = '';
            }
        } else {
            this.birthDate = '';
        }
    }

    private onExpiryInput() {
        this.$v.expireDateFormatted.$touch();
        const parsed = this.parseMMDDYYYY(this.expireDateFormatted);
        if (parsed) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (parsed >= today) {
                this.expireDate = `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}-${String(parsed.getDate()).padStart(2, '0')}`;
            } else {
                this.expireDate = '';
            }
        } else {
            this.expireDate = '';
        }
    }

    private formatToMMDDYYYY(date: Date): string {
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    }

    private parseMMDDYYYY(str: string): Date | null {
        const [mm, dd, yyyy] = str.split('/').map(Number);
        if (!mm || !dd || !yyyy) {
            return null;
        }
        if (mm < 1 || mm > 12 || dd < 1 || dd > 31) {
            return null;
        }
        const date = new Date(yyyy, mm - 1, dd);
        if (date.getMonth() !== mm - 1 || date.getDate() !== dd || date.getFullYear() !== yyyy) {
            return null;
        }
        return date;
    }
}
